const TokenKey = 'web_AccessToken_lowaltitude'
export const Token = {
  set(token) {
    return localStorage.setItem(TokenKey, token)
  },
  get() {
    return localStorage.getItem(TokenKey) || ''
  },
  remove() {
    return localStorage.setItem(TokenKey, '')
  },
}

// 来源路径
const referencePath = 'reference_path_lowaltitude'
export function getReferencePath() {
  return localStorage.getItem(referencePath) || ''
}

export function setReferencePath(value) {
  return localStorage.setItem(referencePath, value)
}

export function removeReferencePath() {
  return localStorage.setItem(referencePath, '')
}
